import React from "react";
import {
  Box,
  Chip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useDispatch } from "react-redux";

export default function SingleSelector(props) {
  const [selectedItem, setSelectedItem] = React.useState(
    props.queryParams || "",
  );
  const dispatch = useDispatch();
  const family = props?.family;
  const type = props?.type;
  const options = props?.options || []; // List of options to select from

  const handleChange = (event) => {
    const { value } = event.target;
    setSelectedItem(value);
    dispatch(props.setQueryParams({ [family]: { [type]: value } }));
  };

  React.useEffect(() => {
    setSelectedItem(props.queryParams || "");
  }, [props.queryParams]);

  return (
    <React.Fragment>
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "stretch",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <FormControl style={{ flex: 8.5, height: "5%" }}>
          <InputLabel id="single-select-label">{props.label}</InputLabel>
          <Select
            labelId="single-select-label"
            id="single-select"
            value={selectedItem}
            onChange={handleChange}
            disabled={props?.disabled ? props?.disabled : false}
          >
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <div
        style={{
          flexDirection: "row",
          width: "100%",
          overflow: "auto",
          maxWidth: "100%",
          display: "inline",
        }}
      >
        {selectedItem && (
          <Chip
            style={{
              marginRight: "1%",
              marginBottom: "0.1%",
            }}
            label={selectedItem}
            onDelete={props.handleDelete(selectedItem)}
            key={selectedItem}
          />
        )}
        {selectedItem ? (
          <Chip
            style={{
              marginRight: "1%",
              marginBottom: "0.1%",
              color: "white",
              backgroundColor: "var(--ale-primary)",
            }}
            label="Clear"
            clickable={true}
            onClick={props.handleClear}
          />
        ) : null}
      </div>
    </React.Fragment>
  );
}
